import React from 'react';
import { Box, Container, Typography, Card, CardContent, Button } from '@mui/material';
import WorkOutlineIcon from '@mui/icons-material/WorkOutline';
import EmailIcon from '@mui/icons-material/Email';

export default function Jobs() {
  return (
    <Box>
      {/* Hero */}
      <Box sx={{ background: 'linear-gradient(135deg, #0d9488 0%, #0f766e 100%)', color: '#fff', py: { xs: 8, md: 12 }, textAlign: 'center' }}>
        <Container maxWidth="md">
          <Typography variant="h2" fontWeight={700} gutterBottom>Join the iAngels Team</Typography>
          <Typography variant="h5" sx={{ opacity: 0.92 }}>
            Help us transform venture investing for the next generation of investors
          </Typography>
        </Container>
      </Box>

      {/* About working here */}
      <Container maxWidth="md" sx={{ py: { xs: 6, md: 8 } }}>
        <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.8, fontSize: '1.1rem', textAlign: 'center', mb: 6 }}>
          At iAngels, we're building the future of venture investing. Our team combines deep tech expertise with financial acumen
          to give investors unprecedented access to Israel's innovation ecosystem. We value curiosity, ownership, and impact —
          and we're always looking for exceptional people who share our mission.
        </Typography>

        {/* Open positions */}
        <Typography variant="h4" fontWeight={700} gutterBottom sx={{ textAlign: 'center' }}>Open Positions</Typography>
        <Card elevation={0} sx={{ border: '1px solid #e0e0e0', borderRadius: 3, mt: 3 }}>
          <CardContent sx={{ py: 6, textAlign: 'center' }}>
            <WorkOutlineIcon sx={{ fontSize: 48, color: '#bdbdbd', mb: 2 }} />
            <Typography variant="h6" color="text.secondary">No open positions at the moment</Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
              Check back soon — we're always growing.
            </Typography>
          </CardContent>
        </Card>

        {/* Contact */}
        <Box sx={{ textAlign: 'center', mt: 6 }}>
          <Typography variant="h5" fontWeight={600} gutterBottom>Interested in joining us?</Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
            Send your CV and a few words about yourself to:
          </Typography>
          <Button href="mailto:team@iangels.com" variant="outlined" startIcon={<EmailIcon />} sx={{ color: '#0d9488', borderColor: '#0d9488', '&:hover': { borderColor: '#0f766e', bgcolor: '#f0fdfa' }, px: 4, py: 1.5, borderRadius: 2 }}>
            team@iangels.com
          </Button>
        </Box>
      </Container>
    </Box>
  );
}
